// extracted by mini-css-extract-plugin
module.exports = {"linkGroup":"NavToggle_linkGroup__pSuV9","link":"NavToggle_link__E2Sqk","active":"NavToggle_active__lLuQM","icon":"NavToggle_icon__6Ehvw"};